import { requestApi } from '../util/network'

/**
 * 代收点登录
 */
export const chainLogin =
    (dlypName, password) =>
      requestApi(
        '/chain_login/login',
        'POST',
        {
          'chain_name': dlypName,
          'chain_passwd': password,
          'client_type': 'wap'
        },
        'member'
      )

/**
 * 代收点注册
 */
export const chainApply =
    (data) =>
      requestApi(
        '/chain_login/apply',
        'POST',
        Object.assign(data,{
            'client_type': 'wap'
        }),
        'member'
      )
/**
 * 代收点文件上传
 */
export const uploadInfoFile =
    (file) =>
      requestApi(
        '/chain_login/upload_image',
        'POST',
        file,
        'member',
        true
      )
